import { render, staticRenderFns } from "./meal-choose.vue?vue&type=template&id=2780992a&scoped=true"
import script from "./meal-choose.vue?vue&type=script&lang=js"
export * from "./meal-choose.vue?vue&type=script&lang=js"
import style0 from "./meal-choose.vue?vue&type=style&index=0&id=2780992a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2780992a",
  null
  
)

export default component.exports